import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/** Asia/Ulaanbaatar is a fixed +08:00 (no DST), whatever the browser timezone is. */
const UB_OFFSET_MINUTES = 480;

/** Format an instant in Ulaanbaatar time, e.g. ubFormat(v, "MM-DD HH:mm"). "-" when empty. */
export function ubFormat(value?: string | Date | null, format = "YYYY-MM-DD HH:mm"): string {
  if (!value) return "-";
  const d = dayjs(value);
  return d.isValid() ? d.utcOffset(UB_OFFSET_MINUTES).format(format) : "-";
}
